import { render, staticRenderFns } from "./centerTop4.vue?vue&type=template&id=e57bfa50&scoped=true"
import script from "./centerTop4.vue?vue&type=script&lang=js"
export * from "./centerTop4.vue?vue&type=script&lang=js"
import style0 from "./centerTop4.vue?vue&type=style&index=0&id=e57bfa50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57bfa50",
  null
  
)

export default component.exports